import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function ProductCard({ product }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="group bg-white border border-dark-600 hover:border-gold transition-all duration-300"
    >
      <div className="overflow-hidden aspect-square bg-dark-800">
        <img
          src={product.images?.[0] || 'https://via.placeholder.com/400x400/EDE9DC/B8A830?text=Sample'}
          alt={product.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <span className="text-gold text-xs tracking-widest uppercase">{product.category?.replace(/-/g, ' ')}</span>
        <h3 className="font-serif text-lg text-ink mt-1 mb-2">{product.title}</h3>
        <p className="text-ink-400 text-sm line-clamp-2">{product.description}</p>
        <Link to={`/products/${product._id}`} className="btn-outline mt-4 text-xs py-2 px-4 inline-block">
          View Details
        </Link>
      </div>
    </motion.div>
  );
}

